import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './dialog.module.scss';
import closeIcon from './../../../globals/images/close.svg';
import ReactDOM from 'react-dom';

class Dialog extends Component {

    getButtons = () => {
        const { buttons } = this.props;
        if (!buttons) return null;
        let buttonStyle = {
            display: 'flex',
            lineHeight: '17px',
            fontFamily: 'Lato',
            fontSize: '14px',
            fontWeight: 'bold',
            color: '#ffffff',
            padding: '6px 22px',
            borderRadius: '15px',
            margin: '10px 10px 10px 0',
            cursor: 'pointer'
        }
        return buttons.map((buttonItem, key) =>
            <div
                className={buttonItem.className}
                style={buttonStyle}
                onClick={buttonItem.onClick}
                key={key}
                id={buttonItem.id ? buttonItem.id : ''}
            >
                {buttonItem.text}
            </div>
        );
    };

    render() {

        const {
            overlayClassName,
            containerClassName,
            title,
            headerClassName,
            isFooterNeeded,
            hideOverflow,
            warningMessage,
            isCloseButtonNeeded
        } = this.props;

        // console.log(this.props);


        const overlayStyles = {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            width: '100%',
            height: '100%',
            zIndex: 100,
            backgroundColor: 'rgba(0, 0, 0, 0.7)'
        };

        return ReactDOM.createPortal(
            (<div className={overlayClassName} style={overlayStyles}>
                <div className={containerClassName} style={{ position: 'relative' }}>
                    {title ? <header><p>{title}</p></header> : null}
                    <content
                        className={styles['content-style']}
                        style={hideOverflow ? this.props.contentStyle : {}}
                    >
                        {this.props.children}
                    </content>
                    {isFooterNeeded ?
                        <footer style={{ height: '50px', minHeight: '50px' }}>
                            {
                                warningMessage ?
                                    <div className={styles.warning}>{warningMessage}</div>
                                    :
                                    null
                            }
                            {this.getButtons()}
                        </footer>
                        : null
                    }
                    {isCloseButtonNeeded ?
                        < img src={closeIcon} className={styles['close-icon']} onClick={() => this.props.onClose()} />
                        : null
                    }
                </div>
            </ div>),
            document.getElementById('root')
        );
    }
}

Dialog.propTypes = {
    closeOnEscape: PropTypes.bool,
    closeIcon: PropTypes.string,
    onClose: PropTypes.func,
    buttons: PropTypes.array,
    overlayClassName: PropTypes.string,
    containerClassName: PropTypes.string
};

Dialog.defaultProps = {
    isOverlay: true,
    buttons: [{
        text: "",
        className: ""
    }],
    headerClassName: {},
    warningMessage: null,
    isFooterNeeded: true,
    isCloseButtonNeeded: false
};

export default Dialog;


// WEBPACK FOOTER //
// /src/components/UiComponents/Dialog/Dialog.js